import { render, staticRenderFns } from "./defaultNetworks.vue?vue&type=template&id=25a85a50"
import script from "./defaultNetworks.vue?vue&type=script&lang=js"
export * from "./defaultNetworks.vue?vue&type=script&lang=js"
import style0 from "./defaultNetworks.vue?vue&type=style&index=0&id=25a85a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports